import React, { Component } from 'react';
import {storyTemplates, checkUploadType,uploadPreview,groupRoles, profilePicValidityCheck} from '../../utils/constants' 
import { Row, Col, Label, Button, CardTitle, CardText, Input, Modal, ModalBody, ModalHeader} from 'reactstrap';
import Toggle from "react-toggle";
import axios from '../../axios';
import * as url from '../../utils/url';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actionCreators from './../../modules/actions/index';
import ReactPlayer from 'react-player/lazy'
import Checkbox from 'rc-checkbox';
import { takeRightWhile } from 'lodash';
import './InviteUsers.css';
import { toastContainer } from '../../utils/toast';



class InviteUsers extends Component {

	constructor(props) {
		super(props);
				this.state = { 
					usersCount:0,
					setImagesPreview:[],
					invitedUsers:[],
					users:[],
					removeUsers:this.props.item.inviteUsers&&this.props.item.invitedUsers.length>0?
							this.props.item.invitedUsers.map(e=>e.value).concat(this.props.user._id): [].concat(this.props.user._id),
					searchImg:'',
					privacy: true,
					isBannerOpen:false,
					item:this.props.item,
					isOpen:false,
					inviteAllUsers:false
			  }
			  this.timer=null
		}

		componentDidMount(){
			axios.get(url.fetchUsers).then(({data})=>{
               this.setState({
				   usersCount:data.data.length
			   })

			}).catch(err =>{

			})
		}

	
		assignedUserDelay = ({ target })=>{
			const { value } = target;  
			this.setState({ searchedUser: value })
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
			  this.handleAssignUser(value);
			}, 1000);
		   
		  }
		  
	
		assignedUserFormat=selectedUser=>{
			let{removeUsers,invitedUsers, item}=this.state
			let { startDate, endDate, name, _id, category}= item
			let event= {
				startDate, endDate, name, eventId: _id,
				category, 
				invitedBy:this.props.user._id,
				eventId:this.props.eventId,

			}
	
			if(removeUsers.indexOf(selectedUser._id)==-1 || removeUsers.length==0){
			let userId = selectedUser._id
			let organizationId = selectedUser.organizationId 
			let u = {
				// ...selectedUser, 
				...event,
				email:selectedUser.email,
				profilePic: selectedUser.profilePic,
				firstName:selectedUser.firstName,
				lastName:selectedUser.lastName,
				userId, 
				role: groupRoles[groupRoles.length-1],
				organizationId, 
				dateJoined: new Date()}
	
			this.setState(prevState=>({
				invitedUsers: prevState.invitedUsers.concat(u),
				removeUsers: prevState.removeUsers.concat(selectedUser._id), 
				users: [],
				searchedUser:''
			}))
			// let result = invitedUsers.concat(u)
			// this.props.setInvitees(result)
			}
		}
	  
	
		getInitials=(user)=>{
			let firstName = user.firstName &&user.firstName.length>0?user.firstName:'N'
			let lastName = user.lastName &&user.lastName.length>0?user.lastName:'N'
			return firstName.charAt(0).toUpperCase()+ lastName.charAt(0).toUpperCase() 
		  }
	
		  removeUser = user =>{
			let{invitedUsers}=this.state 
			invitedUsers = invitedUsers.filter(e=> e.userId!=user.userId)
			this.setState({ invitedUsers })
			// this.props.setInvitees(invitedUsers)
		  }
	
		  handleAssignUser = value => {
	
			if(value && value.length>0){
			  let payload = {
				name:value,
				eventId:this.props.eventId,
				removeUsers: this.state.removeUsers,
				noLoader: true
			  }
			  if(this.props.disableUsersModel){
				let{disableUsersModel}=this.props
				payload = {...payload, disableUsersModel}
			  }
			  axios.post(url.searchUsers, payload).then( (resp,idx) =>{
				let users = resp.data.data
				if(users.length==0){
				  users='none'
				}
				this.setState({users})
			  })
			} else {
			  this.setState({users:[]})
			}
		  
		  }
		 
	
		  inviteUsers=()=>{
			let payload={
				invitedUsers:this.state.invitedUsers,
				event: this.props.item,
				inviteAllUsers:this.state.inviteAllUsers
			}
			let that=this
			

			// that.props.closeInviteModal(invited_length)
			axios.post(url.sendUserInvites, payload).then(({ data }) => {
				let invited_length = that.state.inviteAllUsers ? that.state.usersCount  : that.state.invitedUsers.length
				that.setState({isOpen:false, invitedUsers:[]})
				toastContainer("Invited succesfully","success")
				that.props.closeInviteModal(invited_length) 
			  }).catch((error) => {
				console.log(error);
			  }) 
		  }
	
	
		  closeGroupModal=()=>{
			//   this.setState({isOpen:false})
			this.props.closeInviteModal()
		  }

	render() {
		//suggest, showArchived, isSentiment, isAnonymous, topicsSelected, selectedFilter, filters, topics, disableSubmit, stories, collapseCompleted, categoryDefinitionPopoverOpen, archievedStories, showRemoveFeedConfirmationModal,
		let { searchedUser, invitedUsers,users, item,inviteAllUsers} = this.state;
		let{isOpen}=this.props

		return (
			<Modal isOpen={isOpen} className="ent-obj-link-modal linkTaskItemsModal groupItemsModal inviteAttendees">
			<ModalHeader className="dashboardHeader" charCode="X"
				toggle={this.closeGroupModal}
				>
				<div className="dashboardModalTitle">
					Invite to "<span className="event_details_modal_event_name">{item.name}</span>"
				</div>
			</ModalHeader>
	<ModalBody className="create-stories">

		<div className="my-3">
			<Label>
				Invite all users
			</Label>
			<Toggle 
			className="ml-3"
			checked={inviteAllUsers}
			onChange={(e)=>{
               this.setState({
				   inviteAllUsers:e.target.checked
			   })
			}}
			/>
		</div>

		{
			inviteAllUsers ? null : 		<span className="user_invite_modal_modal_body custom_left_section_menu_fields">
			<div className="floating-label-group grp_invite_user_input_item">
			{invitedUsers.length>0?
			<div className="grp_invite_user_input_invited_users_container">
			{ invitedUsers.map((e,idx)=>{
			return (<span key={e.userId+idx} className="grp_invite_user_input_invited_users">
						{ profilePicValidityCheck(e.profilePic) ?
							<img className="grp_create_search_user_pic" src={e.profilePic}/>
								:
							<span className="spotlightUserInitials" data-letters={this.getInitials(e)}></span>
						}
					{e.firstName} {e.lastName?e.lastName:''}
					<i onClick={()=>this.removeUser(e)}
					className="flaticon-trash"/></span>)
			})}
			</div>
				:
			null}
			<input type="text" id="invitedUsers" className="form-control"
				onChange={this.assignedUserDelay} 
				value={searchedUser}
				autoComplete="off"  placeholder=' '/>
			<label className={invitedUsers.length>0?'floating_label_invite_user':`floating-label`}> Invite members </label>
			{Array.isArray(users) && users.length>0?
			<span className="grp_create_search_user_res">
				<div className="divTable">
				<div className="divTableBody">
					
					{users.map( user => {
						return (
							<div className="divTableRow" onClick={()=>this.assignedUserFormat(user)} key={user._id+user.organizationId}>
							<div className="divTableCell">
								{ profilePicValidityCheck(user.profilePic) ?
								<img className="grp_create_search_user_pic" src={user.profilePic}/>
								:
								<span className="spotlightUserInitials" data-letters={this.getInitials(user)}></span>
								}
								{user.firstName} {user.lastName}
							</div>
							</div>
						)
						})}
					
													
					</div>
				</div>   
				</span>                   
				: users == 'none'?
				<span className="grp_create_search_user_res">
				<div className="divTable">
				<div className="divTableBody">
				<div className="divTableRow">
					<div className="divTableCell">
						User is already invited
					</div>
				</div>
				</div></div></span>
				:null
				}
			</div>

			
			
		  </span>	
		}

<div className={invitedUsers.length>0 || inviteAllUsers?`custom_left_menu_create_button active`:`custom_left_menu_create_button`}
					onClick={invitedUsers.length>0 || inviteAllUsers ?()=>this.inviteUsers():null} >
						Send Invite(s)
				</div>	
				</ModalBody>
			</Modal>
			)
	}
}

const mapStateToProps = state => {
	return {
    user: state.user.profile,
	};
};


const mapDispatchToProps = dispatch => {
	return {
	  storyMetricsChange: (data) => dispatch(actionCreators.storyMetricsChange(data)),
	}
  }


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InviteUsers));


  
  